import * as angular from "angular";
import {IController} from "angular";

export class PlanningVehicleResourcesSelectionTableRowCtrl implements IController {
  resource: any;
  isSelected: any;
  onSelect: Function;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

  ////////////////////////////////////////////////////////////////////////

  onRouteTypeChange(routeType) {
    this.resource.routeType = routeType;
  }

  onSkillsChange(skills) {
    this.resource.allocationSkills = skills;
  }

  onAdd(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onSelect({resource: this.resource})
      }
    }
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningVehicleResourcesSelectionTableRow', {
    bindings: {
      resource: '<',
      isSelected: '<',
      onSelect: '&',
      onRemove: '&'
    },
    template: require('./planning-vehicle-resources-selection-table-row.html').default,
    controller: PlanningVehicleResourcesSelectionTableRowCtrl
  });
